const TokenKey = 'App-Token'
const VisitorKey = 'App-Visitor'
const LNKey = 'App-LN'
const PageCodeKey = 'App-PageCode'

export function setLN(value) {
  return localStorage.setItem(LNKey, value)
}
export function getLN() {
  return localStorage.getItem(LNKey)
}
export function removeLN() {
  return localStorage.removeItem(LNKey)
}
export function setPageCode(value) {
  return localStorage.setItem(PageCodeKey, value)
}

export function getPageCode() {
  return localStorage.getItem(PageCodeKey)
}
export function removePageCode() {
  return localStorage.removeItem(PageCodeKey)
}
export function getToken() {
    // 获取token缓存
    return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}
export function removeToken() {
  return localStorage.removeItem(TokenKey)
}


export function setVisitor(value) {
  return localStorage.setItem(VisitorKey, value)
}
export function getVisitor() {
  return localStorage.getItem(VisitorKey)
}
